import { render } from "./Notes.vue?vue&type=template&id=5eaa896e&scoped=true&ts=true&lang=pug"
import script from "./Notes.vue?vue&type=script&lang=ts&setup=true"
export * from "./Notes.vue?vue&type=script&lang=ts&setup=true"

import "./Notes.vue?vue&type=style&index=0&id=5eaa896e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eaa896e"]])

export default __exports__